import dayjs from 'dayjs';
import { Bomb } from 'lucide-react';

import { FallbackLayout } from '@/components/layouts';
import { Button } from '@/components/ui/button';
import { TextExportMenu } from '@/components/ui/mouse-over-menu';

type MainErrorFallbackProps = {
  error: Error;
  // resetErrorBoundary: (...args: any[]) => void;
};

const MainErrorFallback = ({ error }: MainErrorFallbackProps) => {
  const redirectToHome = () => {
    window.location.assign(window.location.origin);
  };

  return (
    <FallbackLayout>
      <section>
        <div className="flex w-full flex-col space-y-8 text-center text-stone-700">
          <div className="flex w-full justify-center">
            <Bomb className="size-32 drop-shadow-md" />
          </div>

          <h1 className="text-center text-4xl">
            Hmm... Something went wrong! :&#39;-(
          </h1>

          <div className="space-y-1">
            <h2 className="text-xl font-bold">
              The GlyTouCan web page has crashed accidentally due to some issue.
            </h2>
            <p className="text-lg">
              This means that despite thorough debugging by GlyTouCan
              developers, there are potential problems with the web pages.
            </p>
            {error && (
              <p className="text-lg">
                Please report the following information to the system
                administrator.
              </p>
            )}
            <p className="text-lg">We apologize for the inconvenience.</p>
          </div>
          <div className="space-y-8">
            <Button className="drop-shadow-md" onClick={redirectToHome}>
              Refresh
            </Button>

            {error && (
              <div className="flex justify-center">
                <div className="w-full rounded-lg border-2 border-stone-400 bg-stone-100 p-4 drop-shadow-md">
                  <TextExportMenu
                    text={error.stack ?? ''}
                    toClipboard
                    toFile
                    fileOptions={{
                      type: 'text/plain',
                      name: () => {
                        const timestamp = dayjs().format('YYYYMMDD_HH:mm:ss');
                        return `${timestamp}_errors.log`;
                      },
                    }}
                  >
                    <pre className="overflow-auto text-left text-xs">
                      {error.stack}
                    </pre>
                  </TextExportMenu>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </FallbackLayout>
  );
};

MainErrorFallback.displayName = 'MainErrorFallback';

export { MainErrorFallback };
